// Disponibilité mensuelle
const weight = 0.90;
const computeAvailableIncomes = (_, summary) => ({ availableIncomes: ((((summary.rawProfessionalIncomes + (weight * summary.rawRentalIncomes)) / 12) * 0.35) - summary.charges) });

export default computeAvailableIncomes;
